/* @generated from adl module ClientState */

import * as ADL from './runtime/adl';
import * as CodeDiagnostics from './CodeDiagnostics';
import * as FileTreeView from './FileTreeView';
import * as Path from './Path';
import * as PluginTypes from './PluginTypes';
import * as SyntaxHighlighting from './SyntaxHighlighting';
import * as Terminal from './Terminal';

export type EditorFileId = number;

const EditorFileId_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"EditorFileId","version":{"kind":"nothing"}}};

export const snEditorFileId: ADL.ScopedName = {moduleName:"ClientState", name:"EditorFileId"};

export function texprEditorFileId(): ADL.ATypeExpr<EditorFileId> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileId}, parameters : []}};
}

export type EditorFileVersion = number;

const EditorFileVersion_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"EditorFileVersion","version":{"kind":"nothing"}}};

export const snEditorFileVersion: ADL.ScopedName = {moduleName:"ClientState", name:"EditorFileVersion"};

export function texprEditorFileVersion(): ADL.ATypeExpr<EditorFileVersion> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileVersion}, parameters : []}};
}

export type TerminalId = number;

const TerminalId_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"TerminalId","version":{"kind":"nothing"}}};

export const snTerminalId: ADL.ScopedName = {moduleName:"ClientState", name:"TerminalId"};

export function texprTerminalId(): ADL.ATypeExpr<TerminalId> {
  return {value : {typeRef : {kind: "reference", value : snTerminalId}, parameters : []}};
}

export interface EditorFile {
  id: EditorFileId;
  filePath: (Path.PathRelFile|null);
  editorFileContents: EditorFileContents;
}

export function makeEditorFile(
  input: {
    id: EditorFileId,
    filePath: (Path.PathRelFile|null),
    editorFileContents: EditorFileContents,
  }
): EditorFile {
  return {
    id: input.id,
    filePath: input.filePath,
    editorFileContents: input.editorFileContents,
  };
}

const EditorFile_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}},{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}]}},{"annotations":[],"serializedName":"editorFileContents","default":{"kind":"nothing"},"name":"editorFileContents","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileContents"}},"parameters":[]}}]}},"name":"EditorFile","version":{"kind":"nothing"}}};

export const snEditorFile: ADL.ScopedName = {moduleName:"ClientState", name:"EditorFile"};

export function texprEditorFile(): ADL.ATypeExpr<EditorFile> {
  return {value : {typeRef : {kind: "reference", value : snEditorFile}, parameters : []}};
}

export interface EditorFileContents_TextFile {
  kind: 'textFile';
  value: TextFile;
}
export interface EditorFileContents_LoadFileError {
  kind: 'loadFileError';
  value: LoadFileError;
}

export type EditorFileContents = EditorFileContents_TextFile | EditorFileContents_LoadFileError;

export interface EditorFileContentsOpts {
  textFile: TextFile;
  loadFileError: LoadFileError;
}

export function makeEditorFileContents<K extends keyof EditorFileContentsOpts>(kind: K, value: EditorFileContentsOpts[K]) { return {kind, value}; }

const EditorFileContents_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"textFile","default":{"kind":"nothing"},"name":"textFile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TextFile"}},"parameters":[]}},{"annotations":[],"serializedName":"loadFileError","default":{"kind":"nothing"},"name":"loadFileError","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"LoadFileError"}},"parameters":[]}}]}},"name":"EditorFileContents","version":{"kind":"nothing"}}};

export const snEditorFileContents: ADL.ScopedName = {moduleName:"ClientState", name:"EditorFileContents"};

export function texprEditorFileContents(): ADL.ATypeExpr<EditorFileContents> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileContents}, parameters : []}};
}

export interface TextFile {
  version: EditorFileVersion;
  contents: string;
  syntaxHighlightingSpans: (SyntaxHighlighting.SyntaxHighlightingSpan[]|null);
}

export function makeTextFile(
  input: {
    version: EditorFileVersion,
    contents: string,
    syntaxHighlightingSpans: (SyntaxHighlighting.SyntaxHighlightingSpan[]|null),
  }
): TextFile {
  return {
    version: input.version,
    contents: input.contents,
    syntaxHighlightingSpans: input.syntaxHighlightingSpans,
  };
}

const TextFile_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"contents","default":{"kind":"nothing"},"name":"contents","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"syntaxHighlightingSpans","default":{"kind":"nothing"},"name":"syntaxHighlightingSpans","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"SyntaxHighlighting","name":"SyntaxHighlightingSpan"}},"parameters":[]}]}]}}]}},"name":"TextFile","version":{"kind":"nothing"}}};

export const snTextFile: ADL.ScopedName = {moduleName:"ClientState", name:"TextFile"};

export function texprTextFile(): ADL.ATypeExpr<TextFile> {
  return {value : {typeRef : {kind: "reference", value : snTextFile}, parameters : []}};
}

export interface LoadFileError {
  title: string;
  message: string;
}

export function makeLoadFileError(
  input: {
    title: string,
    message: string,
  }
): LoadFileError {
  return {
    title: input.title,
    message: input.message,
  };
}

const LoadFileError_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LoadFileError","version":{"kind":"nothing"}}};

export const snLoadFileError: ADL.ScopedName = {moduleName:"ClientState", name:"LoadFileError"};

export function texprLoadFileError(): ADL.ATypeExpr<LoadFileError> {
  return {value : {typeRef : {kind: "reference", value : snLoadFileError}, parameters : []}};
}

export interface ClientState {
  fileTreeView: FileTreeView.FileTreeView;
  openFiles: EditorFile[];
  terminals: TerminalState[];
  /**
   * Key is the plugin name
   */
  pluginState: {[key: string]: PluginState};
}

export function makeClientState(
  input: {
    fileTreeView: FileTreeView.FileTreeView,
    openFiles: EditorFile[],
    terminals: TerminalState[],
    pluginState: {[key: string]: PluginState},
  }
): ClientState {
  return {
    fileTreeView: input.fileTreeView,
    openFiles: input.openFiles,
    terminals: input.terminals,
    pluginState: input.pluginState,
  };
}

const ClientState_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fileTreeView","default":{"kind":"nothing"},"name":"fileTreeView","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"FileTreeView"}},"parameters":[]}},{"annotations":[],"serializedName":"openFiles","default":{"kind":"nothing"},"name":"openFiles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFile"}},"parameters":[]}]}},{"annotations":[],"serializedName":"terminals","default":{"kind":"nothing"},"name":"terminals","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TerminalState"}},"parameters":[]}]}},{"annotations":[],"serializedName":"pluginState","default":{"kind":"nothing"},"name":"pluginState","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"PluginState"}},"parameters":[]}]}}]}},"name":"ClientState","version":{"kind":"nothing"}}};

export const snClientState: ADL.ScopedName = {moduleName:"ClientState", name:"ClientState"};

export function texprClientState(): ADL.ATypeExpr<ClientState> {
  return {value : {typeRef : {kind: "reference", value : snClientState}, parameters : []}};
}

export interface TerminalState {
  id: TerminalId;
  termSurface: Terminal.TermSurface;
}

export function makeTerminalState(
  input: {
    id: TerminalId,
    termSurface: Terminal.TermSurface,
  }
): TerminalState {
  return {
    id: input.id,
    termSurface: input.termSurface,
  };
}

const TerminalState_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TerminalId"}},"parameters":[]}},{"annotations":[],"serializedName":"termSurface","default":{"kind":"nothing"},"name":"termSurface","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermSurface"}},"parameters":[]}}]}},"name":"TerminalState","version":{"kind":"nothing"}}};

export const snTerminalState: ADL.ScopedName = {moduleName:"ClientState", name:"TerminalState"};

export function texprTerminalState(): ADL.ATypeExpr<TerminalState> {
  return {value : {typeRef : {kind: "reference", value : snTerminalState}, parameters : []}};
}

export interface PluginState {
  workspaceVersion: PluginTypes.WorkspaceVersion;
  codeDiagnostics: CodeDiagnostics.CodeDiagnostic[];
  complete: boolean;
}

export function makePluginState(
  input: {
    workspaceVersion: PluginTypes.WorkspaceVersion,
    codeDiagnostics: CodeDiagnostics.CodeDiagnostic[],
    complete: boolean,
  }
): PluginState {
  return {
    workspaceVersion: input.workspaceVersion,
    codeDiagnostics: input.codeDiagnostics,
    complete: input.complete,
  };
}

const PluginState_AST : ADL.ScopedDecl =
  {"moduleName":"ClientState","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workspaceVersion","default":{"kind":"nothing"},"name":"workspaceVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginTypes","name":"WorkspaceVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"codeDiagnostics","default":{"kind":"nothing"},"name":"codeDiagnostics","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"CodeDiagnostics","name":"CodeDiagnostic"}},"parameters":[]}]}},{"annotations":[],"serializedName":"complete","default":{"kind":"nothing"},"name":"complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"PluginState","version":{"kind":"nothing"}}};

export const snPluginState: ADL.ScopedName = {moduleName:"ClientState", name:"PluginState"};

export function texprPluginState(): ADL.ATypeExpr<PluginState> {
  return {value : {typeRef : {kind: "reference", value : snPluginState}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ClientState.EditorFileId" : EditorFileId_AST,
  "ClientState.EditorFileVersion" : EditorFileVersion_AST,
  "ClientState.TerminalId" : TerminalId_AST,
  "ClientState.EditorFile" : EditorFile_AST,
  "ClientState.EditorFileContents" : EditorFileContents_AST,
  "ClientState.TextFile" : TextFile_AST,
  "ClientState.LoadFileError" : LoadFileError_AST,
  "ClientState.ClientState" : ClientState_AST,
  "ClientState.TerminalState" : TerminalState_AST,
  "ClientState.PluginState" : PluginState_AST
};
